import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Download = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Download" {...props}>
    <path d="M22 15C22.5523 15 23 15.4478 23 16V18C23 20.7614 20.7614 23 18 23H6C3.23858 23 1 20.7614 1 18V16C1.00005 15.4478 1.44775 15 2 15C2.55225 15 2.99995 15.4478 3 16V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V16C21 15.4478 21.4477 15 22 15Z" fill="#000" /><path d="M12 1C12.5523 1 13 1.44772 13 2V12.5859L16.293 9.29297C16.6835 8.90244 17.3165 8.90244 17.707 9.29297C18.0976 9.68349 18.0976 10.3165 17.707 10.707L12.707 15.707C12.3165 16.0976 11.6835 16.0976 11.293 15.707L6.29297 10.707C5.90244 10.3165 5.90244 9.68349 6.29297 9.29297C6.68349 8.90244 7.31651 8.90244 7.70703 9.29297L11 12.5859V2C11 1.44772 11.4477 1 12 1Z" fill="#000" />
  </StyledIcon>
));

Download.displayName = 'Download';

export { Download };
